var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96803 9.8623C5.94708 9.8623 6.85998 9.57377 7.63396 9.08852L10.28 11.718C10.4719 11.9082 10.7299 12 11.0011 12C11.5766 12 12 11.5607 12 11.0033C12 10.741 11.9074 10.4852 11.7155 10.2951L9.08931 7.68525C9.63175 6.89836 9.94267 5.94754 9.94267 4.93115C9.94267 2.21639 7.70673 0 4.96803 0C2.23594 0 0 2.21639 0 4.93115C0 7.63934 2.23594 9.8623 4.96803 9.8623ZM4.96803 8.43934C3.02977 8.43934 1.4355 6.85902 1.4355 4.93115C1.4355 3.00328 3.02977 1.42295 4.96803 1.42295C6.9129 1.42295 8.50717 3.00328 8.50717 4.93115C8.50717 6.85902 6.9129 8.43934 4.96803 8.43934Z",
    fill: "#393E42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e1354cf7cbf00db1766663511102d9b6.svg";
export { ForwardRef as ReactComponent };